import Vue from 'vue'
import VueGtm from 'vue-gtm'
// import { createGtm } from 'vue-gtm'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import paths from './paths.js'
// eslint-disable-next-line
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: paths,
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()

    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    /* eslint-disable */
    to.meta.navbarOpenStatus = false
    to.meta.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'

    store.dispatch('layout/setNavbarOpen', false)
  }

  next()
})

//router遷移時に実行したい
router.beforeEach((to, from, next) => {
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

//GTM
  Vue.use(VueGtm, {
    id: 'G-E2TL9WWP1Y', // Your GTM ID
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: [''] // If router, you can exclude some routes name (case insensitive) (optional)
  });

export default router
